<!--<div class="custom-validate" [ngClass]="{'no-style': defaultStyle, 'mb-2': isHTML}" [hidden]="!message || !observeMessage">-->
<!--  <span *ngIf="!isHTML" class="d-grid">{{message}}</span>-->
<!--  <span *ngIf="isHTML" [innerHTML]="message" class="d-grid" style="line-height: 1.5rem;"></span>-->
<!--</div>-->
<div class="ng-invalid-feedback">{{message}}</div>
